var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5673_9177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.83 21.3499C4.72998 21.3499 4.72998 19.0399 4.72998 12.0999C4.72998 5.15992 4.72998 2.84992 11.83 2.84992C13.287 2.78226 14.7447 2.96491 16.14 3.38992",
    stroke: "#0054E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.01 8.88005C18.9986 8.88005 19.8 8.07864 19.8 7.09005C19.8 6.10146 18.9986 5.30005 18.01 5.30005C17.0214 5.30005 16.22 6.10146 16.22 7.09005C16.22 8.07864 17.0214 8.88005 18.01 8.88005Z",
    fill: "#0054E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 10.81L17.29 15.09L18.46 16.16C18.8058 16.4791 19.0139 16.9202 19.04 17.39L19.2 20.63C19.2082 20.8575 19.1269 21.0791 18.9736 21.2474C18.8203 21.4156 18.6072 21.5171 18.38 21.53C18.1541 21.5384 17.9339 21.4585 17.7659 21.3073C17.598 21.1561 17.4954 20.9455 17.48 20.72L17.32 17.93C17.3108 17.7742 17.2696 17.6218 17.1991 17.4825C17.1286 17.3431 17.0302 17.2198 16.91 17.12L15.27 15.76C15.0971 15.6011 14.9657 15.4023 14.8873 15.1809C14.8088 14.9596 14.7857 14.7224 14.82 14.49L15.19 11.86L14.87 12L14.09 14.58C14.0252 14.7822 13.8855 14.9519 13.6995 15.0542C13.5135 15.1565 13.2954 15.1836 13.09 15.13C12.9793 15.0975 12.8764 15.0425 12.7879 14.9685C12.6994 14.8945 12.6271 14.803 12.5755 14.6998C12.5239 14.5966 12.4941 14.4838 12.488 14.3686C12.4819 14.2534 12.4996 14.1381 12.54 14.03L13.59 11.26C13.7049 10.9657 13.9313 10.7285 14.22 10.6L16.68 9.55005L17.02 9.65005C17.2616 9.72514 17.4696 9.88195 17.6082 10.0936C17.7469 10.3052 17.8076 10.5585 17.78 10.81Z",
    fill: "#0054E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89 15.76L16.28 17.02L15.16 20.92C15.1332 21.0245 15.0861 21.1226 15.0213 21.2089C14.9565 21.2951 14.8753 21.3677 14.7824 21.4225C14.6895 21.4773 14.5867 21.5132 14.4799 21.5282C14.3731 21.5433 14.2644 21.5371 14.16 21.51C14.0459 21.487 13.9378 21.4405 13.8426 21.3735C13.7474 21.3065 13.6671 21.2204 13.6069 21.1207C13.5467 21.0211 13.5079 20.91 13.493 20.7945C13.478 20.679 13.4872 20.5617 13.52 20.45L14.89 15.76Z",
    fill: "#0054E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 11.52L17.83 13.3L19.14 14.5C19.2052 14.5665 19.283 14.6194 19.3688 14.6555C19.4547 14.6915 19.5469 14.7101 19.64 14.7101C19.7331 14.7101 19.8253 14.6915 19.9112 14.6555C19.997 14.6194 20.0748 14.5665 20.14 14.5H20.19C20.2578 14.4356 20.3118 14.358 20.3486 14.2721C20.3855 14.1861 20.4045 14.0935 20.4045 14C20.4045 13.9065 20.3855 13.8139 20.3486 13.728C20.3118 13.642 20.2578 13.5645 20.19 13.5L18.04 11.52Z",
    fill: "#0054E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14001 12.6399H10.33",
    stroke: "#0054E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92 15.0199L11.22 12.7199L8.88 10.3799",
    stroke: "#0054E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5673_9177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.1f8348f0cc888ee7fb5943c08bf03b38.svg";
export { ForwardRef as ReactComponent };